module.exports = __webpack_public_path__ + "img/banner-2.13560267.png";